import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import Answer from "./Answer";

export const Answers = () => {
  const navigate = useNavigate();
  const { questionId } = useParams();
  const [answers, setAnswers] = useState([]);
  const [question, setQuestion] = useState({});
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    question?.user &&
      api
        .get(`/user/getUserdataById/` + question?.user?.id)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [question]);
  // alert(questionId);
  useEffect(() => {
    api
      .get(`/questions/get-question-by-id/${questionId}`)
      .then((res) => {
        console.log("question", res.data);
        setQuestion(res.data);
      })
      .catch((err) => console.log(err));
    api
      .get(`/questions/answers-of-particular-question/${questionId}`)
      .then((res) => {
        console.log('blooper questio id',questionId)
        console.log("answers", res.data);
        setAnswers(res.data);
      })
      .catch((err) => console.log(err));
  }, [questionId]);
  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className=" answers">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}

        <div className="col-md-12 col-12 pl-5 pr-5">
          <div className="">
            {/* <div className="row pt-3 mb-3 border-bottom border-dark pb-3 question__container">
              <div className="col-lg-6 col-md-6 col-12">
                <h6 className="post-name">
                  <strong>{question?.user?.name}</strong>
                </h6>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <h6 className="post-date">
                  Posted:{" "}
                  <strong>
                    {new Date(question?.createdAt).toDateString()}
                  </strong>
                </h6>
              </div>
              <div className="col-12">
                <h6 className="question">{question?.question}</h6>
              </div>
            
              <div className="col-12">
                <p className="description">{question?.description}</p>
              </div>
              {question?.image && (
                <div className="col-lg-6 col-md-6 col-12 question__image__container">
                  <img src={question.image} />
                </div>
              )}
              <div className="language">
                <div className="tags">
                  {question?.tags?.map((t) => (
                    <span className="tag-span">{t}</span>
                  ))}
                </div>
              </div>
            </div> */}
            <Card sx={{ width: "100%" }}>
              <CardHeader
                avatar={
                  <Stack direction="column">
                    {uploader?.profile ? (
                      <Avatar src={uploader?.profile} />
                    ) : (
                      <Avatar
                        sx={{ bgcolor: "colorThree.main" }}
                        aria-label="recipe"
                      >
                        {question?.user?.name?.at(0)?.toUpperCase()}
                      </Avatar>
                    )}
                  </Stack>
                }
                // action={
                //   <IconButton aria-label="settings">
                //     <MoreVertIcon />
                //   </IconButton>
                // }
                title={question?.user?.name?.toUpperCase()}
                subheader="September 14, 2016"
              />
              {question?.image && (
                <CardMedia
                  component="img"
                  height="50"
                  width="50"
                  image={question?.image}
                  alt="Paella dish"
                />
              )}

              <CardContent>
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    marginBottom: "10px",
                    fontWeight: "500",
                  }}
                  color="fontPrimaryColor.main"
                  className="question__title"
                  // onClick={() => navigate(`/answers/${question._id}`)}
                >
                  {question?.question}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {question?.description}
                </Typography>
                <Box className="language mt-4 bg-white">
                  <Box className="tags bg-white">
                    {question?.tags?.map((t) => (
                      <Typography className="tag-span">{t}</Typography>
                    ))}
                  </Box>
                </Box>
                <Box className="mt-5">
                  <Typography sx={{ fontSize: "1.2rem", fontWeight: "500" }}>
                    Answers
                  </Typography>

                  <div className="answer__container">
                    {answers.length > 0 &&
                      answers.map((ans) => (
                        // <div className="ans">
                        //   <h1>{ans.user.name}</h1>
                        //   <p>{ans.answer}</p>
                        // </div>
                        <Answer ans={ans} question={question} />
                      ))}
                  </div>
                  {/* answer */}
                </Box>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};
